'use client'

import { useTopicContext } from './TopicContext'

// The coverage line's article count, made useful: opens the slide-in
// articles panel with the story's full coverage. It inherits the line's
// type (the mocks' 13px, 2026-11-01) and only adds the underline.
export default function ArticlesCountTrigger() {
  const { allArticles, openArticlesModal } = useTopicContext()
  const count = allArticles?.length || 0
  if (!count) return null

  return (
    <button
      onClick={() => openArticlesModal(allArticles, 'All coverage')}
      className="underline decoration-foreground/60 decoration-[1.5px] underline-offset-4 transition-colors hover:text-foreground hover:decoration-foreground"
      aria-label={`View all ${count} articles`}
    >
      {count} articles
    </button>
  )
}
